import React from "react";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, Text, useMantineTheme, Avatar, Paper, ActionIcon } from '@mantine/core';
import { IconMessageChatbot, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils, ROOT_BASE_URL } from "../../utils/globalVariables";
import { getPropInSubLevelRole, safetyDecodeJWT, safeValue, CustomerCategoryIcon, sqlDateToIsoDate, arrCekDoubleBarangFisik } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber } from "../../utils/accessing";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

import ImageLightBox2 from "../../components/general/ImageLightBox2";

import PaperWrapper from "../../components/utilities/PaperWrapper";
import TanggalMasukProject from "../../components/utilities/TanggalMasukProject";
import NomorNota from "../../components/utilities/NomorNota";
import BarangCategory from "../../components/utilities/BarangCategory";
import BarangNama from "../../components/utilities/BarangNama";
import BarangKeluhan from "../../components/utilities/BarangKeluhan";
import BarangKelengkapan from "../../components/utilities/BarangKelengkapan";
import BarangFormCek from "../../components/utilities/BarangFormCek";
import BarangProjectNotaFoto from "../../components/utilities/BarangProjectNotaFoto";
import BarangDPBiaya from "../../components/utilities/BarangDPBiaya";
import DiskonBlock from "../../components/utilities/DiskonBlock";
import BarangDPBiayaMetode from "../../components/utilities/BarangDPBiayaMetode";
import RekomendasiPenerima from "../../components/utilities/RekomendasiPenerima";
import RekomendasiPenerimaInfo from "../../components/utilities/RekomendasiPenerimaInfo";
import ProjectNotaCatatan from "../../components/utilities/ProjectNotaCatatan";
import PriorityNota from "../../components/utilities/PriorityNota";
import DateLinePengecekan from "../../components/utilities/DateLinePengecekan";
import DateLineSelesai from "../../components/utilities/DateLineSelesai";

import DeadlinePengecekan from "../../components/utilities/DeadlinePengecekan";
import DeadlineSelesai from "../../components/utilities/DeadlineSelesai";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";

const ProjectNotaAdd = ({
  stateData,
  fnRefreshNotaIndex,
  fnSuccessCreateNota
}) => {

  const mountedRef = React.useRef(true);

  const { URI1, URI2, URI3 } = useParams(); /* URI1 = customer id, URI2 = project id, URI3 = flag new nota */
  const navigate = useNavigate();

  const theme = useMantineTheme();
  const { loginContext, handleSetLoginContext } = useLoginContext();

  const utilsRef = React.useRef({
    projectProcess: utils.projectProcess.nota.value,
    projectIsCancel: '0',
    userAccess: [
      // role.owner.subLevel.owner.slugSubLevel,
      // role.admin.subLevel.admin_kepala.slugSubLevel,
      // role.admin.subLevel.admin_staf.slugSubLevel,
    ]
  })

  const notificationId = React.useRef({
    errorGetDataProject: 'projectNotaAdd-1',

    errorSubmitData: 'projectNotaAdd-2',
    successSubmitData: 'projectNotaAdd-3',
  })

  const constProjectNotaCustomer = {
    id: 'addProjectNotaCustomer',
    label: 'Customer',
    withAsterisk: false,
    placeholder: 'Customer',
    value: {
      id: '',
      name: '',
      gender: '1',
      address: '',
      contact: '',
      categorySlug: '',
      categoryName: '',
      customerGroupId: '',
      customerGroupName: '',
      customerIdCardNumber: '',

      diskonId: '',
      diskonFlag: '',
      diskonName: '',
      diskonType: '',
      diskonValue: '',
      diskonDeductedFrom: '',
      diskonVoucherCode: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaNomor = {
    id: 'addProjectNotaNomor',
    label: 'Nomor Nota',
    withAsterisk: false,
    placeholder: 'Nomor Nota',
    value: {
      id: '',
      userCreatedName: '',
      userCreatedSubLevel: '',
      createdDateTime: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaTanggalMasuk = {
    id: 'addProjectNotaTanggalMasuk',
    label: 'Tanggal Masuk',
    withAsterisk: true,
    placeholder: 'Tanggal Masuk',
    value: new Date(),
    description: '',
    error: ''
  }

  const constProjectNotaBarangCategory = {
    id: 'addProjectNotaBarangCategory',
    label: 'Kategori Barang',
    withAsterisk: true,
    placeholder: 'Kategori Barang',
    value: {
      id: ''
    },
    description: '',
    error: ''
  }

  const constProjectNotaBarangNama = {
    id: 'addProjectNotaBarangNama',
    label: 'Nama Barang',
    withAsterisk: true,
    placeholder: 'Nama Barang',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaBarangKeluhan = {
    id: 'addProjectNotaBarangKeluhan',
    label: 'Keluhan / Kerusakan',
    withAsterisk: true,
    placeholder: 'Keluhan / Kerusakan',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaBarangKelengkapan = {
    id: 'addProjectNotaBarangKelengkapan',
    label: 'Kelengkapan Barang',
    withAsterisk: false,
    placeholder: 'Kelengkapan Barang',
    value: [],
    description: '',
    error: ''
  }

  const constProjectNotaBarangFormCek = {
    id: 'addProjectNotaBarangFormCek',
    label: 'Form Ceklis',
    withAsterisk: false,
    placeholder: 'Form Ceklis',
    value: {
      masterId: '',
      detil: []
    },
    description: '',
    error: ''
  }

  const constProjectNotaBarangFoto = {
    id: 'addProjectNotaBarangFoto',
    label: 'Foto Barang',
    withAsterisk: true,
    placeholder: 'Foto Barang',
    value: [],
    description: '',
    error: ''
  }

  const constProjectNotaDPBiaya = {
    id: 'addProjectNotaDPBiaya',
    label: 'Uang Muka',
    withAsterisk: false,
    placeholder: 'Uang Muka',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaDPMetode = {
    id: 'addProjectNotaDPMetode',
    label: 'Metode Bayar',
    withAsterisk: false,
    placeholder: 'Metode Bayar',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaRekomendasiPengerjaan = {
    id: 'addProjectNotaRekomendasiPengerjaan',
    label: 'Rekomendasi Pengerjaan',
    withAsterisk: false,
    placeholder: 'Rekomendasi Pengerjaan',
    value: {
      id: '',
      name: '',
      gender: '',
      level: '',
      subLevel: '',
    },
    description: '',
    error: ''
  }

  const constProjectNotaRekomendasiCatatan = {
    id: 'addProjectNotaRekomendasiCatatan',
    label: 'Catatan Rekomendasi',
    withAsterisk: false,
    placeholder: 'Catatan Rekomendasi',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaCatatan = {
    id: 'addProjectNotaCatatan',
    label: 'Catatan Nota',
    withAsterisk: false,
    placeholder: 'Catatan Nota',
    value: '',
    description: '',
    error: ''
  }

  const constProjectNotaProjectPriority = {
    id: 'addProjectNotaProjectPriority',
    label: 'Prioritas Project',
    withAsterisk: true,
    placeholder: 'Prioritas Project',
    value: '3',
    description: '',
    error: ''
  }

  const constProjectNotaDateLinePengecekan = {
    id: 'addProjectNotaDateLinePengecekan',
    label: 'Deadline Pengecekan',
    withAsterisk: true,
    placeholder: 'Deadline Pengecekan',
    value: new Date(),

    hasPengecekan: null,
    dateLine: null,
    today: null,

    description: '',
    error: ''
  }

  const constProjectNotaDateLineSelesai = {
    id: 'addProjectNotaDateLineSelesai',
    label: 'Deadline Selesai',
    withAsterisk: true,
    placeholder: 'Deadline Selesai',
    value: new Date(),

    tanggalSelesai: null,
    dateLine: null,
    today: null,

    description: '',
    error: ''
  }

  const [data, setData] = React.useState({
    projectDrawer: false,
    projectDataInitLoading: false,

    projectCustomer: constProjectNotaCustomer,
    projectNotaNomor: constProjectNotaNomor,
    projectNotaTanggalMasuk: constProjectNotaTanggalMasuk,

    projectNotaBarangCategory: constProjectNotaBarangCategory,
    projectNotaBarangNama: constProjectNotaBarangNama,
    projectNotaBarangKeluhan: constProjectNotaBarangKeluhan,

    projectNotaBarangKelengkapan: constProjectNotaBarangKelengkapan,
    projectNotaBarangFormCek: constProjectNotaBarangFormCek,
    projectNotaBarangFoto: constProjectNotaBarangFoto,

    projectNotaDPBiaya: constProjectNotaDPBiaya,
    projectNotaDPMetode: constProjectNotaDPMetode,

    projectNotaRekomendasiPengerjaan: constProjectNotaRekomendasiPengerjaan,
    projectNotaRekomendasiCatatan: constProjectNotaRekomendasiCatatan,

    projectNotaCatatan: constProjectNotaCatatan,
    projectNotaPriority: constProjectNotaProjectPriority,

    projectNotaDateLinePengecekan: constProjectNotaDateLinePengecekan,
    projectNotaDateLineSelesai: constProjectNotaDateLineSelesai,

    imageLightboxImages: '',
    imageLightboxTitle: '',
    imageLightboxIndex: '',
    imageLightboxFieldName: '',
    imageLightboxShow: false,

    feedbackModal: false,

    dataSelector: {
      barangCategory: [],
      barangFormCek: [],
      barangNamaSuggestion: [],
      teknisi: [],
      discountVoucher: []
    },

    submitConfirmationModal: false,
    submitLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const setDataProject = ({ stateData, stateDataBarangCategory, stateDataBarangFormCek, stateDataTeknisi, stateDataBarangNamaSuggestion, stateDataDiscountVoucher }) => {
    if (Array.isArray(stateData) && stateData.length > 0) {
      setData(d => ({
        ...d,
        dataSelector: {
          ...d.dataSelector,
          barangCategory: stateDataBarangCategory,
          barangFormCek: stateDataBarangFormCek,
          barangNamaSuggestion: stateDataBarangNamaSuggestion,
          teknisi: stateDataTeknisi,
          discountVoucher: stateDataDiscountVoucher
        },
        projectCustomer: {
          ...d.projectCustomer,
          value: {
            ...d.projectCustomer.value,
            id: safeValue(stateData[0].customer_id, ''),
            name: safeValue(stateData[0].customer_name, '[Nama]'),
            gender: safeValue(stateData[0].customer_gender, '1'),
            address: safeValue(stateData[0].customer_address, '[Alamat]'),
            contact: safeValue(stateData[0].customer_contact, '[Kontak]'),
            categorySlug: safeValue(stateData[0].customer_category_slug, ''),
            categoryName: safeValue(stateData[0].customer_category_name, ''),

            customerGroupId: safeValue(stateData[0].customer_group_id, ''),
            customerGroupName: safeValue(stateData[0].customer_group_name, ''),
            customerIdCardNumber: safeValue(stateData[0].customer_id_card_number, ''),

            diskonId: safeValue(stateData[0].diskon_voucher_id, ''),
            diskonFlag: safeValue(stateData[0].diskon_voucher_flag, ''),
            diskonName: safeValue(stateData[0].diskon_voucher_name, ''),
            diskonType: safeValue(stateData[0].diskon_voucher_type, ''),
            diskonValue: safeValue(stateData[0].diskon_voucher_value, ''),
            diskonDeductedFrom: safeValue(stateData[0].diskon_deducted_from, ''),
            diskonVoucherCode: safeValue(stateData[0].diskon_voucher_code, ''),
          }
        },
        projectNotaNomor: {
          ...d.projectNotaNomor,
          value: {
            ...d.projectNotaNomor.value,
            id: safeValue(stateData[0].project_id, ''),
            userCreatedName: safeValue(stateData[0].project_created_user_name, ''),
            userCreatedSubLevel: safeValue(stateData[0].project_created_user_sub_level, ''),
            createdDateTime: stateData[0].project_created_datetime
          }
        },
        projectNotaTanggalMasuk: {
          ...d.projectNotaTanggalMasuk,
          value: sqlDateToIsoDate(safeValue(stateData[0].tanggal_nota, ''), new Date())
        },
        projectNotaBarangCategory: {
          ...d.projectNotaBarangCategory,
          value: {
            ...d.projectNotaBarangCategory.value,
            id: safeValue(stateData[0].barang_category_id, '')
          }
        },
        projectNotaBarangNama: {
          ...d.projectNotaBarangNama,
          value: safeValue(stateData[0].barang_nama, '')
        },
        projectNotaBarangKeluhan: {
          ...d.projectNotaBarangKeluhan,
          value: safeValue(stateData[0].barang_keluhan, '')
        },
        projectNotaBarangKelengkapan: {
          ...d.projectNotaBarangKelengkapan,
          value: stateData[0].barang_kelengkapan
        },
        projectNotaBarangFormCek: {
          ...d.projectNotaBarangFormCek,
          value: {
            ...d.projectNotaBarangFormCek.value,
            masterId: safeValue(stateData[0].barang_form_cek_id, ''),
            detil: stateData[0].barang_form_cek_detil,
          }
        },
        projectNotaBarangFoto: {
          ...d.projectNotaBarangFoto,
          value: stateData[0].barang_foto_nota
        },
        projectNotaDPBiaya: {
          ...d.projectNotaDPBiaya,
          value: Number(stateData[0].biaya_dp) === 0 ? '' : stateData[0].biaya_dp
        },
        projectNotaDPMetode: {
          ...d.projectNotaDPMetode,
          value: safeValue(stateData[0].biaya_dp_metode, '')
        },
        projectNotaRekomendasiPengerjaan: {
          ...d.projectNotaRekomendasiPengerjaan,
          value: {
            ...d.projectNotaRekomendasiPengerjaan.value,
            id: safeValue(stateData[0].recommendation_penerima_user_id, ''),
            name: safeValue(stateData[0].penerima_rekomendasi_nama, ''),
            gender: safeValue(stateData[0].penerima_rekomendasi_gender, ''),
            level: safeValue(stateData[0].penerima_rekomendasi_level, ''),
            subLevel: safeValue(stateData[0].penerima_rekomendasi_sub_level, ''),
          }
        },
        projectNotaRekomendasiCatatan: {
          ...d.projectNotaRekomendasiCatatan,
          value: safeValue(stateData[0].recommendation_info, '')
        },
        projectNotaCatatan: {
          ...d.projectNotaCatatan,
          value: safeValue(stateData[0].catatan_nota, '')
        },
        projectNotaPriority: {
          ...d.projectNotaPriority,
          value: safeValue(stateData[0].project_priority, '')
        },
        projectNotaDateLinePengecekan: {
          ...d.projectNotaDateLinePengecekan,
          value: stateData[0].date_line_pengecekan ? sqlDateToIsoDate(stateData[0].date_line_pengecekan, null) : null,
          today: stateData[0].today ? stateData[0].today : null,
          hasPengecekan: stateData[0].has_pengecekan ? stateData[0].has_pengecekan : null,
          dateLine: stateData[0].date_line_pengecekan ? stateData[0].date_line_pengecekan : null,
        },
        projectNotaDateLineSelesai: {
          ...d.projectNotaDateLineSelesai,
          value: stateData[0].date_line_selesai ? sqlDateToIsoDate(stateData[0].date_line_selesai, null) : null,
          today: stateData[0].today ? stateData[0].today : null,
          tanggalSelesai: stateData[0].tanggal_selesai ? stateData[0].tanggal_selesai : null,
          dateLine: stateData[0].date_line_selesai ? stateData[0].date_line_selesai : null,
        },
      }))
    }
  }

  const AllErrorBox = ({ stateErrorArray = [] }) => {
    return (
      <Box>
        {Object.keys(stateErrorArray).map(key => {
          return (
            <Text
              key={key}
              c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[6]}
              size={theme.fontSizes.sm}
              mb={stateErrorArray.length === (Number(key) + 1) ? 'lg' : 'xs'}
            >
              {stateErrorArray[key]}
            </Text>
          )
        })}
      </Box>
    )
  }

  const checkingData = () => {
    setData(d => ({
      ...d,
      projectCustomer: { ...d.projectCustomer, error: '' },
      projectNotaNomor: { ...d.projectNotaNomor, error: '' },
      projectNotaTanggalMasuk: { ...d.projectNotaTanggalMasuk, error: '' },
      projectNotaBarangCategory: { ...d.projectNotaBarangCategory, error: '' },
      projectNotaBarangNama: { ...d.projectNotaBarangNama, error: '' },
      projectNotaBarangKeluhan: { ...d.projectNotaBarangKeluhan, error: '' },
      projectNotaBarangFoto: { ...d.projectNotaBarangFoto, error: '' },
      projectNotaPriority: { ...d.projectNotaPriority, error: '' },
      projectNotaDPMetode: { ...d.projectNotaDPMetode, error: '' },
      projectNotaDateLinePengecekan: { ...d.projectNotaDateLinePengecekan, error: '' },
      projectNotaDateLineSelesai: { ...d.projectNotaDateLineSelesai, error: '' },
    }))

    if (validator.isEmpty(data.projectCustomer.value.id, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectCustomer: { ...d.projectCustomer, error: 'Customer wajib dipilih!', } }));
    } else if (validator.isEmpty(data.projectNotaNomor.value.id, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaNomor: { ...d.projectNotaNomor, error: 'Nomor nota wajib diisi!', } }));
    } else if (!validator.isDate(data.projectNotaTanggalMasuk.value)) {
      setData(d => ({ ...d, projectNotaTanggalMasuk: { ...d.projectNotaTanggalMasuk, error: 'Tanggal masuk wajib diisi!', } }));
    } else if (validator.isEmpty(data.projectNotaBarangCategory.value.id, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaBarangCategory: { ...d.projectNotaBarangCategory, error: 'Kategori barang wajib diisi!', } }));
    } else if (validator.isEmpty(data.projectNotaBarangNama.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaBarangNama: { ...d.projectNotaBarangNama, error: 'Nama barang wajib diisi!', } }));
    } else if (validator.isEmpty(data.projectNotaBarangKeluhan.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaBarangKeluhan: { ...d.projectNotaBarangKeluhan, error: 'Keluhan/kerusakan barang wajib diisi!', } }));
    } else if (Array.isArray(data.projectNotaBarangFoto.value) && data.projectNotaBarangFoto.value.length <= 0) {
      setData(d => ({ ...d, projectNotaBarangFoto: { ...d.projectNotaBarangFoto, error: 'Foto barang wajib diisi!', } }));
    } else if (!validator.isEmpty(data.projectNotaDPBiaya.value, { ignore_whitespace: true }) && validator.isEmpty(data.projectNotaDPMetode.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaDPMetode: { ...d.projectNotaDPMetode, error: 'Metode bayar wajib dipilih jika ada uang muka!', } }));
    } else if (validator.isEmpty(data.projectNotaPriority.value, { ignore_whitespace: true })) {
      setData(d => ({ ...d, projectNotaPriority: { ...d.projectNotaPriority, error: 'Prioritas project wajib dipilih!', } }));
    } else if (!validator.isDate(data.projectNotaDateLinePengecekan.value)) {
      setData(d => ({ ...d, projectNotaDateLinePengecekan: { ...d.projectNotaDateLinePengecekan, error: 'Deadline pengecekan wajib diisi!', } }));
    } else if (!validator.isDate(data.projectNotaDateLineSelesai.value)) {
      setData(d => ({ ...d, projectNotaDateLineSelesai: { ...d.projectNotaDateLineSelesai, error: 'Deadline selesai wajib diisi!', } }));
    } else {
      setData(d => ({ ...d, submitConfirmationModal: true }))
    }
  }

  const createNota = () => {
    setData(d => ({ ...d, submitLoading: true }))

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('project_id', data.projectNotaNomor.value.id);
    formDT.append('project_process_nota', utils.projectProcess.nota.value);
    formDT.append('project_process_antrian', utils.projectProcess.antrian.value);
    formDT.append('project_is_cancel', '0');
    formDT.append('arr_cek_double_barang_fisik', JSON.stringify(arrCekDoubleBarangFisik()));

    axios({
      method: 'post',
      url: BE_API_TWO + '/create_nota',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, submitLoading: false, submitConfirmationModal: false }));

      if (response.data.flag_status === 'isset') {
        navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

        setData(d => ({ ...d, projectDrawer: false }));

        fnSuccessCreateNota();
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorSubmitData,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'double-barang-fisik') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Barang ini sedang dalam proses service dan belum dilakukan pengambilan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        submitLoading: false,
        submitConfirmationModal: false
      }))

      notifications.show({
        id: notificationId.current.errorSubmitData,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  React.useEffect(() => {
    if (URI1 && URI2 && URI3) {

      setData(d => ({
        ...d,

        projectDataInitLoading: true,
        projectDrawer: true,

        projectCustomer: { ...d.projectCustomer, error: '' },
        projectNotaNomor: { ...d.projectNotaNomor, error: '' },
        projectNotaTanggalMasuk: { ...d.projectNotaTanggalMasuk, error: '' },
        projectNotaBarangCategory: { ...d.projectNotaBarangCategory, error: '' },
        projectNotaBarangNama: { ...d.projectNotaBarangNama, error: '' },
        projectNotaBarangKeluhan: { ...d.projectNotaBarangKeluhan, error: '' },
        projectNotaBarangFoto: { ...d.projectNotaBarangFoto, error: '' },
        projectNotaPriority: { ...d.projectNotaPriority, error: '' },
        projectNotaDPMetode: { ...d.projectNotaDPMetode, error: '' },
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('flag_all', utils.flagAll);
      formDT.append('customer_id', URI1);
      formDT.append('project_id', URI2);
      formDT.append('flag_generate_new_nota', URI3);
      formDT.append('project_process_nota', utils.projectProcess.nota.value);
      formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);
      formDT.append('project_is_cancel', '0');

      axios({
        method: 'post',
        url: BE_API_TWO + '/select_project_by_customer_id__project_nota',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, projectDataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setDataProject({
            stateData: response.data.data_project,
            stateDataBarangCategory: response.data.data_barang_category,
            stateDataBarangFormCek: response.data.data_barang_form_cek,
            stateDataTeknisi: response.data.data_teknisi,
            stateDataBarangNamaSuggestion: response.data.data_barang_name_suggestion,
            stateDataDiscountVoucher: response.data.data_discount_voucher,
          });

          fnRefreshNotaIndex();
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetDataProject,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data-customer') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, projectDrawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data customer tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'wrong-flag') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, projectDrawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Terdapat kesalahan. Proses tidak dapat dilanjutkan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'project-not-found') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, projectDrawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Project tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'id-not-enough') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, projectDrawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Kode ID Transaksi sudah tidak dapat ditambahkan lagi. Mulai kembali transaksi pada hari esok.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          projectDataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetDataProject,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, navigate, stateData.triggerUseEffect, URI1, URI2, URI3, stateData.stateMenu, stateData.stateSubMenu, stateData.stateTab, fnRefreshNotaIndex])

  const closeDrawer = ({ cleanURICustomerId = true }) => {
    if (cleanURICustomerId) {
      navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });
    }

    setData(d => ({ ...d, projectDrawer: false }));
  }

  return (
    <React.Fragment>
      <Drawer
        opened={data.projectDrawer}
        onClose={() => closeDrawer({ cleanURICustomerId: true })}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}
        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={() => closeDrawer({ cleanURICustomerId: true })}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Group position='apart' style={{ width: '100%' }}>
              <Text>Nota Baru</Text>
              <ActionIcon
                size='lg'
                variant="light"
                color="green"
                radius='xl'
                onClick={() => setData(d => ({ ...d, feedbackModal: true }))}
              >
                <IconMessageChatbot size='1.25rem' stroke={1.25} />
              </ActionIcon>
            </Group>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase',
            width: '100%',
          }
        })}
      >
        {!data.projectDataInitLoading &&
          <Box py='md' sx={{ minHeight: '500px' }}>
            <Box mb='1rem'>
              <PaperWrapper>
                <Group align='flex-start'>
                  <Avatar
                    radius="xl"
                  >
                    <CustomerCategoryIcon
                      stateCustomerCategory={data.projectCustomer.value.categorySlug}
                      stateSize='1.5rem'
                      stateColor={theme.colorScheme === 'light' ? '#000' : '#fff'}
                    />
                  </Avatar>

                  <Box>
                    <Text size="sm" fw={500}>
                      {data.projectCustomer.value.name}
                    </Text>

                    <Text size="xs">
                      {data.projectCustomer.value.categoryName}
                    </Text>

                    <Text size="xs">
                      {data.projectCustomer.value.customerGroupName ? data.projectCustomer.value.customerGroupName : '[Customer Group]'}
                    </Text>

                    <Text size="xs">
                      {data.projectCustomer.value.customerIdCardNumber ? `Id Card: ${data.projectCustomer.value.customerIdCardNumber}` : '[Id Card Number]'}
                    </Text>

                    <Text size="xs">
                      {data.projectCustomer.value.address}
                    </Text>

                    {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) &&
                      <Text size="xs">
                        {data.projectCustomer.value.contact}
                      </Text>
                    }
                  </Box>
                </Group>
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <NomorNota
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaNomor
                  }}

                  fnSuccessBatalNota={() => {
                    closeDrawer({ cleanURICustomerId: true });
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <Box mb='1rem'>
                  <BarangCategory
                    stateData={{
                      customerId: data.projectCustomer.value.id,
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: utilsRef.current.projectProcess,
                      projectIsCancel: utilsRef.current.projectIsCancel,
                      userAccess: utilsRef.current.userAccess,

                      data: data.projectNotaBarangCategory,
                      dataBarangCategory: data.dataSelector.barangCategory
                    }}

                    fnOnChange={(val, arrSuggest) => {
                      setData(d => ({
                        ...d,
                        dataSelector: {
                          ...d.dataSelector,
                          barangNamaSuggestion: arrSuggest
                        },
                        projectNotaBarangCategory: {
                          ...d.projectNotaBarangCategory,
                          value: {
                            ...d.projectNotaBarangCategory.value,
                            id: val
                          }
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />
                </Box>

                <Box mb='1rem'>
                  <BarangNama
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: utilsRef.current.projectProcess,
                      projectIsCancel: utilsRef.current.projectIsCancel,
                      userAccess: utilsRef.current.userAccess,

                      data: data.projectNotaBarangNama,
                      barangNamaSuggestion: data.dataSelector.barangNamaSuggestion
                    }}

                    fnOnChange={(val) => {
                      setData(d => ({
                        ...d,
                        projectNotaBarangNama: {
                          ...d.projectNotaBarangNama,
                          value: val
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />
                </Box>

                <BarangKeluhan
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaBarangKeluhan,
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangKeluhan: {
                        ...d.projectNotaBarangKeluhan,
                        value: val
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <BarangKelengkapan
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaBarangKelengkapan,
                    barangNama: data.projectNotaBarangNama.value,
                    kerusakan: data.projectNotaBarangKeluhan.value,
                    customer: data.projectCustomer.value.name,
                    tanggalMasuk: data.projectNotaTanggalMasuk.value
                  }}

                  fnOnChange={(array) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangKelengkapan: {
                        ...d.projectNotaBarangKelengkapan,
                        value: array
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <BarangFormCek
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaBarangFormCek,
                    dataBarangFormCek: data.dataSelector.barangFormCek
                  }}

                  fnOnChangeMaster={(valMaster, valDetil) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          masterId: valMaster,
                          detil: valDetil
                        }
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}

                  fnUpdateDetil={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          detil: val
                        }
                      }
                    }))
                  }}

                  fnOnChangeDetil={(arrayDetil) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFormCek: {
                        ...d.projectNotaBarangFormCek,
                        value: {
                          ...d.projectNotaBarangFormCek.value,
                          detil: arrayDetil
                        }
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <BarangProjectNotaFoto
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaBarangFoto,
                  }}

                  fnOnChange={(array) => {
                    setData(d => ({
                      ...d,
                      projectNotaBarangFoto: {
                        ...d.projectNotaBarangFoto,
                        value: array
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}

                  fnClickPhoto={(object) => setData(d => ({
                    ...d,
                    imageLightboxImages: object.images,
                    imageLightboxTitle: object.title,
                    imageLightboxIndex: object.index,
                    imageLightboxFieldName: object.fieldName,
                    imageLightboxShow: object.show,
                  }))}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <DiskonBlock
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    dataDiscountVoucher: data.dataSelector.discountVoucher,

                    diskonId: data.projectCustomer.value.diskonId,
                    diskonFlag: data.projectCustomer.value.diskonFlag,
                    diskonName: data.projectCustomer.value.diskonName,
                    diskonType: data.projectCustomer.value.diskonType,
                    diskonValue: data.projectCustomer.value.diskonValue,
                    diskonDeductedFrom: data.projectCustomer.value.diskonDeductedFrom,
                    diskonVoucherCode: data.projectCustomer.value.diskonVoucherCode,
                  }}

                  fnOnChange={(obj) => {
                    setData(d => ({
                      ...d,
                      projectCustomer: {
                        ...d.projectCustomer,
                        value: {
                          ...d.projectCustomer.value,
                          diskonId: obj.diskonId,
                          diskonFlag: obj.diskonFlag,
                          diskonName: obj.diskonName,
                          diskonType: obj.diskonType,
                          diskonValue: obj.diskonValue,
                          diskonDeductedFrom: obj.diskonDeductedFrom,
                          diskonVoucherCode: obj.voucherCode
                        }
                      }
                    }))
                  }}

                  fnOnChangeVoucherCode={(obj) => {
                    setData(d => ({
                      ...d,
                      projectCustomer: {
                        ...d.projectCustomer,
                        value: {
                          ...d.projectCustomer.value,
                          diskonVoucherCode: obj.diskonVoucherCode
                        }
                      }
                    }))
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <BarangDPBiaya
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaDPBiaya,
                  }}

                  fnOnChange={(dp, metode) => {
                    setData(d => ({
                      ...d,
                      projectNotaDPBiaya: {
                        ...d.projectNotaDPBiaya,
                        value: Number(dp) === 0 ? '' : dp
                      },
                      projectNotaDPMetode: {
                        ...d.projectNotaDPMetode,
                        value: safeValue(metode, '')
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />

                {Number(data.projectNotaDPBiaya.value) !== 0 &&
                  <Box mt='1rem'>
                    <BarangDPBiayaMetode
                      stateData={{
                        projectId: data.projectNotaNomor.value.id,
                        projectProcess: utilsRef.current.projectProcess,
                        projectIsCancel: utilsRef.current.projectIsCancel,
                        userAccess: utilsRef.current.userAccess,

                        data: data.projectNotaDPMetode,
                      }}

                      fnOnChange={(metode) => {
                        setData(d => ({
                          ...d,
                          projectNotaDPMetode: {
                            ...d.projectNotaDPMetode,
                            value: safeValue(metode, '')
                          }
                        }))
                        fnRefreshNotaIndex();
                      }}
                    />
                  </Box>
                }
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <RekomendasiPenerima
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaRekomendasiPengerjaan,
                    dataTeknisi: data.dataSelector.teknisi
                  }}

                  fnOnChange={(object) => {
                    object === null ?
                      setData(d => ({
                        ...d,
                        projectNotaRekomendasiPengerjaan: {
                          ...d.projectNotaRekomendasiPengerjaan,
                          value: constProjectNotaRekomendasiPengerjaan.value
                        },
                        projectNotaRekomendasiCatatan: {
                          ...d.projectNotaRekomendasiCatatan,
                          value: ''
                        }
                      }))
                      :
                      setData(d => ({
                        ...d,
                        projectNotaRekomendasiPengerjaan: {
                          ...d.projectNotaRekomendasiPengerjaan,
                          value: {
                            ...d.projectNotaRekomendasiPengerjaan.value,
                            id: object.id,
                            name: object.name,
                            gender: object.gender,
                            level: object.level,
                            subLevel: object.subLevel,
                          }
                        }
                      }));

                    fnRefreshNotaIndex();
                  }}
                />

                {data.projectNotaRekomendasiPengerjaan.value.id &&
                  <Box mt='1rem'>
                    <RekomendasiPenerimaInfo
                      stateData={{
                        projectId: data.projectNotaNomor.value.id,
                        projectProcess: utilsRef.current.projectProcess,
                        projectIsCancel: utilsRef.current.projectIsCancel,
                        userAccess: utilsRef.current.userAccess,

                        data: data.projectNotaRekomendasiCatatan,
                      }}

                      fnOnChange={(val) => {
                        setData(d => ({
                          ...d,
                          projectNotaRekomendasiCatatan: {
                            ...d.projectNotaRekomendasiCatatan,
                            value: val
                          }
                        }))
                        fnRefreshNotaIndex();
                      }}
                    />
                  </Box>
                }
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <Box mb='1rem'>
                  <TanggalMasukProject
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: utilsRef.current.projectProcess,
                      projectIsCancel: utilsRef.current.projectIsCancel,
                      userAccess: utilsRef.current.userAccess,

                      data: data.projectNotaTanggalMasuk,
                    }}

                    fnOnChange={(val) => {
                      setData(d => ({
                        ...d,
                        projectNotaTanggalMasuk: {
                          ...d.projectNotaTanggalMasuk,
                          value: sqlDateToIsoDate(safeValue(val, ''), new Date())
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />
                </Box>

                <Box mb='1rem'>
                  <DateLinePengecekan
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: utilsRef.current.projectProcess,
                      projectIsCancel: utilsRef.current.projectIsCancel,
                      userAccess: utilsRef.current.userAccess,

                      data: data.projectNotaDateLinePengecekan,
                      minDate: data.projectNotaTanggalMasuk.value,
                    }}

                    fnOnChange={(arr) => {
                      setData(d => ({
                        ...d,
                        projectNotaDateLinePengecekan: {
                          ...d.projectNotaDateLinePengecekan,
                          error: '',
                          value: Array.isArray(arr) && (arr.length > 0) ? sqlDateToIsoDate(safeValue(arr[0].date_line_pengecekan, null), null) : null,

                          hasPengecekan: Array.isArray(arr) && (arr.length > 0) ? arr[0].has_pengecekan : null,
                          today: Array.isArray(arr) && (arr.length > 0) ? arr[0].today : null,
                          dateLine: Array.isArray(arr) && (arr.length > 0) ? arr[0].date_line_pengecekan : null,
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />

                  <DeadlinePengecekan
                    stateMT=".5rem"
                    stateToday={data.projectNotaDateLinePengecekan.today}
                    stateDeadlinePengecekan={data.projectNotaDateLinePengecekan.dateLine}
                    stateHasPengecekan={data.projectNotaDateLinePengecekan.hasPengecekan}
                  />
                </Box>

                <Box mb='1.5rem'>
                  <DateLineSelesai
                    stateData={{
                      projectId: data.projectNotaNomor.value.id,
                      projectProcess: utilsRef.current.projectProcess,
                      projectIsCancel: utilsRef.current.projectIsCancel,
                      userAccess: utilsRef.current.userAccess,

                      data: data.projectNotaDateLineSelesai,
                      minDate: data.projectNotaDateLinePengecekan.value,
                    }}

                    fnOnChange={(arr) => {
                      setData(d => ({
                        ...d,
                        projectNotaDateLineSelesai: {
                          ...d.projectNotaDateLineSelesai,
                          error: '',
                          value: Array.isArray(arr) && (arr.length > 0) ? sqlDateToIsoDate(safeValue(arr[0].date_line_selesai, null), null) : null,
                          today: Array.isArray(arr) && (arr.length > 0) ? arr[0].today : null,
                          dateLine: Array.isArray(arr) && (arr.length > 0) ? arr[0].date_line_selesai : null,
                          tanggalSelesai: Array.isArray(arr) && (arr.length > 0) ? arr[0].tanggal_selesai : null,
                        }
                      }))
                      fnRefreshNotaIndex();
                    }}
                  />

                  <DeadlineSelesai
                    stateMT=".5rem"
                    stateToday={data.projectNotaDateLineSelesai.today}
                    stateDeadlineSelesai={data.projectNotaDateLineSelesai.dateLine}
                    stateTanggalSelesai={data.projectNotaDateLineSelesai.tanggalSelesai}
                  />
                </Box>

                <PriorityNota
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaPriority,
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaPriority: {
                        ...d.projectNotaPriority,
                        value: safeValue(val, '')
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box mb='1rem'>
              <PaperWrapper>
                <ProjectNotaCatatan
                  stateData={{
                    projectId: data.projectNotaNomor.value.id,
                    projectProcess: utilsRef.current.projectProcess,
                    projectIsCancel: utilsRef.current.projectIsCancel,
                    userAccess: utilsRef.current.userAccess,

                    data: data.projectNotaCatatan,
                  }}

                  fnOnChange={(val) => {
                    setData(d => ({
                      ...d,
                      projectNotaCatatan: {
                        ...d.projectNotaCatatan,
                        value: safeValue(val, '')
                      }
                    }))
                    fnRefreshNotaIndex();
                  }}
                />
              </PaperWrapper>
            </Box>

            <Box my='xl'>
              <Text size='sm' mb='xs' color="dimmed">
                Setelah klik Simpan Nota, transaksi ini akan berlanjut ke proses Antrian.
              </Text>

              <AllErrorBox
                stateErrorArray={[
                  data.projectCustomer.error,
                  data.projectNotaNomor.error,
                  data.projectNotaTanggalMasuk.error,
                  data.projectNotaBarangCategory.error,
                  data.projectNotaBarangNama.error,
                  data.projectNotaBarangKeluhan.error,
                  data.projectNotaBarangFoto.error,
                  data.projectNotaDPMetode.error,
                  data.projectNotaPriority.error,
                  data.projectNotaDateLinePengecekan.error,
                  data.projectNotaDateLineSelesai.error,
                ]}
              />

              <Button
                fullWidth
                // variant="default"
                // color='teal'
                loading={data.submitLoading}
                onClick={checkingData}
              >
                Simpan Nota
              </Button>
            </Box>
          </Box>
        }

        {data.projectDataInitLoading &&
          <Box py='md' sx={{ minHeight: '500px' }}>
            <Paper px="md" py='xl'>
              <Text ta='center' size='sm'>Loading Data..</Text>
            </Paper>
          </Box>
        }
      </Drawer>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ImageLightBox2
        stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

        stateTitle={data.imageLightboxTitle}
        stateSelectedIndex={data.imageLightboxIndex}
        stateShow={data.imageLightboxShow}
        fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
      />

      <ModalTakeAction
        stateShow={data.submitConfirmationModal}
        fnHide={() => setData(d => ({ ...d, submitConfirmationModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Simpan Nota'
        stateButtonActionPx='xs'
        stateButtonActionColor=""
        stateButtonActionLoading={data.submitLoading}
        fnButtonAction={createNota}
      >
        <Text size='sm'>Pastikan semua data sudah terisi dengan benar. Simpan Nota ?</Text>
      </ModalTakeAction>

      <FeedbackDrawer
        stateShow={data.feedbackModal}
        fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
        stateData={{
          data: stateData.data,
        }}
        fnShouldUpdateIndex={fnRefreshNotaIndex}
      />
    </React.Fragment>
  )
}

export default React.memo(ProjectNotaAdd);